<template>
  <modal :show.sync="comDetails">
    <h4 slot="header" class="title title-up">
      {{ $t("app.modules.messages.details.title") }}
    </h4>

    <ValidationObserver ref="formEditCom" v-slot="{ handleSubmit }">
      <form
        @submit.prevent="handleSubmit(submitEditMessage)"
        id="formEditCom"
        name="formEditCom"
      >
        <div class="row">
          <div class="col-sm-12">
            <ValidationProvider
              name="minLength"
              rules="required|min:2"
              v-slot="{ passed, failed }"
            >
              <fg-input
                type="text"
                disabled
                :error="failed ? $t('app.validation.min_length') + '2' : null"
                :hasSuccess="passed"
                name="minLength"
                :label="$t('app.modules.messages.headers.name')"
                v-model="item.nombreComunicacion"
              >
              </fg-input>
            </ValidationProvider>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <ValidationProvider
              name="required"
              rules="required"
              v-slot="{ passed, failed }"
            >
              <fg-input
                :error="failed ? $t('app.validation.required') : null"
                :hasSuccess="passed"
                name="required"
                :label="$t('app.modules.messages.headers.registration_date')"
              >
                <el-date-picker
                  disabled
                  type="date"
                  placeholder="Date Picker"
                  v-model="item.fechaRegistro"
                >
                </el-date-picker>
              </fg-input>
            </ValidationProvider>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <ValidationProvider
              name="required"
              rules="required"
              v-slot="{ passed, failed }"
            >
              <fg-input
                :error="failed ? $t('app.validation.required') : null"
                :hasSuccess="passed"
                name="required"
                :label="$t('app.modules.messages.headers.ini_date')"
              >
                <el-date-picker
                  disabled
                  type="date"
                  placeholder="Date Picker"
                  v-model="item.fechaInicio"
                >
                </el-date-picker>
              </fg-input>
            </ValidationProvider>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12">
            <ValidationProvider
              name="required"
              rules="required"
              v-slot="{ passed, failed }"
            >
              <fg-input
                :error="failed ? $t('app.validation.required') : null"
                :hasSuccess="passed"
                name="required"
                :label="$t('app.modules.messages.headers.end_date')"
              >
                <el-date-picker
                  type="date"
                  disabled
                  placeholder="Date Picker"
                  v-model="item.fechaFin"
                >
                </el-date-picker>
              </fg-input>
            </ValidationProvider>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-4">
            {{ $t("app.modules.messages.headers.public") }} <br />

            <n-switch disabled v-model="item.tipoUsuarioVisualizar"></n-switch>
          </div>

          <div class="col-sm-4">
            {{ $t("app.general.active") }} <br />

            <n-switch disabled v-model="item.activo"></n-switch>
          </div>

          <div class="col-sm-4 form-group has-label">
            <label>{{
              $t("app.modules.order_entry_schedule.headers.order_category")
            }}</label>
            <template>
              <el-select
                disabled
                class="select-danger"
                placeholder="Single Select"
                v-model="item.tipoComunicado_idTipoComunicado"
              >
                <el-option
                  v-for="option in types"
                  class="select-danger"
                  :value="option.id"
                  :label="option.text"
                  :key="option.id"
                >
                </el-option>
              </el-select>
            </template>
          </div>
        </div>

        <div clas="row">
          <b>{{ $t("app.translations") }}</b>
          <div
            class="col-sm-12"
            v-for="lang in item.langs"
            :key="lang.idioma_idIdioma"
          >
            <b>{{ lang.idioma }}</b>
            <ValidationProvider
              name="minLength"
              rules="required|min:2"
              v-slot="{ passed, failed }"
            >
              <fg-input
                type="text"
                disabled
                :error="failed ? $t('app.validation.min_length') + '2' : null"
                :hasSuccess="passed"
                name="minLength"
                :label="$t('app.modules.messages.add.text')"
                v-model="lang.textoComunicacion"
              >
              </fg-input>
            </ValidationProvider>
            <ValidationProvider
              name="minLength"
              rules="required|min:2"
              v-slot="{ passed, failed }"
            >
              <fg-input
                type="text"
                disabled
                :error="failed ? $t('app.validation.min_length') + '2' : null"
                :hasSuccess="passed"
                name="minLength"
                :label="$t('app.modules.messages.add.link')"
                v-model="lang.enlaceComunicacion"
              >
              </fg-input>
            </ValidationProvider>
            <template>
              <card style="width: 20rem;">
                <!--<img
                  slot="image"
                  class="card-img-top"
                  :src="server + '/' + lang.imagenComunicacion"
                  alt="Card image cap"
                />-->
                <el-image
                  style="width: 100px; height: 100px"
                  :src="server + lang.imagenComunicacion"
                  :preview-src-list="[server + lang.imagenComunicacion]"
                >
                </el-image>
                <p class="card-text">
                  {{ $t("app.modules.messages.headers.current_image") }}
                </p>
              </card>
            </template>
            <!--<div class="demo-image__preview">
              <el-image
                style="width: 100px; height: 100px"
                src="https://appsdev.blob.core.windows.net/imagesapi/dfgds.jpg"
                :preview-src-list="[
                  'https://appsdev.blob.core.windows.net/imagesapi/dfgds.jpg'
                ]"
              >
              </el-image>
            </div>-->
          </div>
        </div>

        <div
          slot="footer"
          style="margin-top: 10px; padding-top: 20px; border-top: outset"
          class="text-right"
        >
          <n-button
            class="pull-left btn-secondary"
            @click.native="cancelAdd()"
            >{{ $t("app.buttons.cancel") }}</n-button
          >
        </div>
      </form>
    </ValidationObserver>
  </modal>
</template>

<script>
import Vue from "vue";
import { mapState } from "vuex";

export default {
  components: {},
  data() {
    return {
      server: "",
      types: [
        {
          id: 1,
          text: this.$t("app.modules.messages.types.promo")
        },
        {
          id: 2,
          text: this.$t("app.modules.messages.types.advice")
        },
        {
          id: 3,
          text: this.$t("app.modules.messages.types.bulletin")
        }
      ],
      item: {
        idComunicacion: 0,
        nombreComunicacion: "",
        fechaInicio: new Date(),
        fechaFin: new Date(),
        tipoUsuarioVisualizar: false,
        fechaRegistro: new Date(),
        tipoComunicado_idTipoComunicado: 0,
        activo: false,
        langs: []
      },
      file: {},
      files: [],
      comDetails: false,
      datePickerModal: false,
      currLang: 0,
      typeSelected: 0,
      currText: "",
      currLink: ""
    };
  },
  computed: {
    ...mapState(["availableLangs"])
  },
  created() {
    this.item.langs = [];
    this.server = process.env.VUE_APP_API_ENDPOINT;
  },
  mounted() {
    EventBus.$on("comunicados-details", async item => {
      this.item.idComunicacion = item.idComunicacion;
      this.item.comunicacion_idComunicacion = item.comunicacion_idComunicacion;
      this.item.nombreComunicacion = item.nombreComunicacion;
      this.item.fechaInicio = item.fechaInicio;
      this.item.fechaFin = item.fechaFin;
      this.item.tipoUsuarioVisualizar = item.tipoUsuarioVisualizar;
      this.item.fechaRegistro = item.fechaRegistro;
      this.item.tipoComunicado_idTipoComunicado =
        item.tipoComunicado_idTipoComunicado;
      this.item.activo = item.activo;
      await this.initDetailMessage();
      console.log(this.item);
      this.comDetails = true;
    });
  },
  methods: {
    async initDetailMessage() {
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });
      var datas = {
        id: this.item.comunicacion_idComunicacion,
        claveIdioma: this.$store.state.lang,
        usuario: this.$store.state.user.idUsuario
      };
      await this.$http
        .post(route("Comunicaciones/getTraduccionesComunicaciones"), datas)
        .then(
          async response => {
            if (response.body.code === 200) {
              this.item.langs = response.body.traducciones;
              console.log(this.item);
            } else {
              this.notifyMessage("danger", this.$t("app.promps.error"));
            }
          },
          error => {
            console.log(error);
            this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        )
        .finally(() => {});
      this.$swal.close();
    },
    cancelAdd() {
      this.$refs.formEditCom.reset();
      this.comDetails = false;
    },
    async submitEditMessage() {
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });
      await this.editMessage();
      this.$swal.close();
    },
    async editMessage() {
      console.log("Cerrar esta pantalla");
    }
  }
};
</script>
